import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import FamiliaActivo from './FamiliaActivo';




interface FamiliaActivoTableProps {
  data: FamiliaActivo[];
  columns: TableColumn<FamiliaActivo>[];
  customStyles: Record<string, any>;
}

const FamiliaActivoTable: React.FC<FamiliaActivoTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<FamiliaActivo>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default FamiliaActivoTable;